import logoIcon from "@/assets/fav_monago.png";
import logoLockup from "@/assets/logo-icon.webp";
import { cn } from "@/lib/utils";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  /**
   * When false only the diamond icon renders (used by the
   * collapsed sidebar rail). Two assets are bundled:
   * - the full lockup (diamond + "monago" wordmark) for header use
   * - the diamond-only PNG for the icon variant
   */
  showWordmark?: boolean;
  className?: string;
}

// Height tokens drive the rendered size for both variants.
// Lockup aspect 630:131 (~4.81:1) → width follows from height.
// Icon aspect 654:610 (~1.07:1) → rendered as a near-square box.
const HEIGHT_BY_SIZE = {
  sm: "h-7",
  md: "h-8",
  lg: "h-10",
} as const;

const SQUARE_BY_SIZE = {
  sm: "h-7 w-7",
  md: "h-8 w-8",
  lg: "h-10 w-10",
} as const;

export function Logo({
  size = "md",
  showWordmark = true,
  className,
}: LogoProps) {
  if (showWordmark) {
    return (
      <img
        src={logoLockup}
        alt="Monago"
        className={cn(HEIGHT_BY_SIZE[size], "w-auto select-none", className)}
        draggable={false}
      />
    );
  }

  return (
    <img
      src={logoIcon}
      alt="Monago"
      className={cn(
        SQUARE_BY_SIZE[size],
        "shrink-0 object-contain select-none",
        className
      )}
      draggable={false}
    />
  );
}
